import { HttpErrorResponse } from '@angular/common/http';

export interface ApiErrorBody {
  result: string;
  error: string[];
}

const isApiErrorBody = (body: unknown): body is ApiErrorBody =>
  !!body &&
  typeof body === 'object' &&
  Array.isArray((body as ApiErrorBody).error) &&
  (body as ApiErrorBody).error.every((message) => typeof message === 'string');

export const apiErrorMessage = (
  error: HttpErrorResponse,
  fallback: string
): string => {
  if (!isApiErrorBody(error.error)) {
    return fallback;
  }
  const messages = error.error.error.filter((message) => !!message?.trim());
  return messages.length ? messages.join('. ') : fallback;
};
